var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AnonymousLayout',[_c('form',{attrs:{"action":_vm.action,"method":"post"}},[_c('input',{attrs:{"type":"hidden","name":"Authority"}}),_c('input',{attrs:{"type":"hidden","name":"Audience"}}),_c('input',{attrs:{"type":"hidden","name":"Url"}}),_c('input',{attrs:{"type":"hidden","name":"AccessToken"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }